import { Link } from "react-router-dom"
import { Typography, Card, CardContent, CardMedia  } from "@mui/material"
import {CheckCircle, ViewDayOutlined} from '@mui/icons-material'
import { demoThumbnailUrl, demoVideoTitle, demoChannelUrl, demoChannelTitle, demoVideoUrl } from "./utils/constant"



const VideoCard = ({ video: {id: {
    videoId }, snippet }}) =>    

    <Card sx={{width: { xs: '100%', sm: '358px', md: "220px"}, boxShadow: "none", borderRadius:0}}>
    <Link to={videoId ? `/video/${videoId}`: demoVideoUrl}>
    <CardMedia 
    image={snippet?.thumbnails?.high?.url} 
    alt={snippet?.title}
    sx={{width: {
      xs: '100%', sm: '358px', md:"220px"
    }, height: 150}} />

    </Link>
<CardContent sx={{ background: '#1e1e1e', height: '106px '}}>
<Link to={videoId? `/video/${videoId}` : demoVideoUrl}>
<Typography variant="subtitle1" fontWeight="bold" color={"#fff"}>
{snippet?.title.slice(0, 60) || demoVideoTitle.slice(0, 60)}
</Typography>
</Link>

<Link to={snippet?.channelId ? `/channel/${snippet?.channelId}` : demoChannelUrl} >
<Typography variant="subtitle2" color="gray">
  {snippet?.channelTitle || demoChannelTitle}
  <CheckCircle sx={{ fontSize: "12px", color: "gray", ml: "5px" }} />
</Typography>
</Link> 


</CardContent>
    
    </Card>
  


export default VideoCard
